import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const send = props => (
  <Icon viewBox="0 0 16 16" {...props}>
    <g>
      <title>Shape</title>
      <path d="M1.515 1.001L15.02 7.663c.628.324.627 1.234 0 1.559L1.507 15.896c-.628.325-1.364-.237-1.212-.952l1.15-5.478 7.547-.884c.238-.022.238-.281 0-.303l-7.59-.848L.26 1.955C.15 1.24.844.677 1.515 1z"
        fill="currentColor" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default send;



// WEBPACK FOOTER //
// ./chat-app/svgIcons/components/send.js